import Details from '@/components/pages/InformationPortal/ProfilePage/NewDetail/Details.vue'
import MemberDetails from '@/components/pages/InformationPortal/Members/Details/Details.vue'
export default{
    name:'APPDetails',
    components:{
        Details,
        MemberDetails,
        'ShareMessage': () => import('@/components/component/Reuse/ShareMessage/ShareMessage.vue')
    },
    props: {
        isMember: {
            type: Boolean,
            default: false
        },
        userInformation: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            isShare: false,
            articleToShare: {},
            shareType: '',
            updateArticleShareCount: {}
        }
    },
    methods: {
        /**
         * to open up the share article popup
         */
        activateSharePopup (sharedItem) {
            this.isShare = true
            this.articleToShare = sharedItem.article
            this.shareType = sharedItem.type
        },
        /**
         * to close the popup
         */
        handleClose () {
            this.isShare = false
            this.articleToShare = {}
            this.shareType = ''
        },
        /**
         * change update share article count
         */
        changeUpdateArticleShareCount (article) {
            this.updateArticleShareCount = article
        }
    }
}